import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TextField,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import { blue } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import React, { useEffect, useState } from "react";
import Loading from "../../../pages/Loading";
import FileUpload from "../Components/FileUpload";
import CreateEquitableMarital from "./EquitableClaimsMaritalModal/Create";
import DeleteEquitableMarital from "./EquitableClaimsMaritalModal/Delete";
import EditEquitableMarital from "./EquitableClaimsMaritalModal/Edit";
import ShowNoteComponent from "./ShowNoteComponent";
import { debounce } from "lodash";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import moment from "moment";
import { Create } from "@material-ui/icons";
import GreenCheckBadge from "../Components/Badge";
import SortTableHeader from "../Components/SortTableHeader";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function EquitableClaimMaritalRow(props) {
  const { row, client_case_id, setClaims } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);

  const handleChange = debounce(async (property, value) => {
    try {
      if (value && value._isAMomentObject) {
        const date_dt = new Date(value);
        const new_date = new Date(
          date_dt.getFullYear(),
          date_dt.getMonth(),
          date_dt.getDate(),
          10,
          56,
          0
        );
        row[property] = new_date;
      } else {
        row[property] = value;
      }

      const response = await Axios.put(
        `api/estate/equitable/claim/${row.id}`,
        row
      );

      if (response && response.status === 200) {
        setClaims(response.data.data);
      }
    } catch (err) {
      console.error("Error updating property:", err);
    }
  }, 500);

  const positions = [
    "Husband",
    "Wife",
    "Joint",
    "Client",
    "Spouse",
    "Third Party",
    "Other"
  ];

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.description ?? "N/A"} <Position position={row.position} />
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.value ?? ""} as of ({moment(row.value_date).format("L")})
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.client_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left">
          <ShowNoteComponent row={row} api='api/estate/equitable/claim' />
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteEquitableMarital row={row} setClaims={setClaims} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'equitable-claim-marital'} />
          </div>
           <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Against which estate? :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      <NativeSelect
                        className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                        inputProps={{
                          name: 'party',
                        }}
                        defaultValue={row.party}
                        onChange={(e) => handleChange('party', e.target.value)}
                      >
                        <option value="me" selected>Me</option>
                        <option value="spouse">My Spouse</option>
                      </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Value of claim :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.value} onChange={(e) => handleChange('value', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      How calculated :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.method} onChange={(e) => handleChange('method', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Notes :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.notes} onChange={(e) => handleChange('notes', e.target.value)} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name/Control of:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      <NativeSelect
                        className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                        inputProps={{
                          name: 'positions',
                        }}
                        onChange={(e) => handleChange('position', e.target.value)}
                        defaultValue={row.position}
                      >
                        {
                          positions.map((position, index) => {
                            return (
                              <option key={index} value={position}>{position}</option>
                            )
                          })
                        }
                      </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function EquitableClaimMarital(props) {
  const { handleOpen } = props;
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [claims, setClaims] = useState([]);
    const [order, setOrder]                 = useState('desc');
    const [orderBy, setOrderBy]             = useState('id');
    const headCells = [
      {
        id: 'description',
        numeric: false,
        disablePadding: true,
        label: 'Description',
      },
      {
        id: 'value',
        numeric: true,
        disablePadding: true,
        label: 'Value',
      },  
      {
        id: 'client_sp',
        numeric: true,
        disablePadding: false,
        label: 'Client SP',
      },
      {
        id: 'spouse_sp',
        numeric: true,
        disablePadding: false,
        label: 'Spouse SP',
      },
      {
        id: 'net_value',
        numeric: true,
        disablePadding: false,
        label: 'Net Value',
      },
      {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
      },
    ];
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc'; 
      var newValue = sortByProperty(claims, property, isAsc ? 'desc' : 'asc');
  
      setClaims(newValue);
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    function sortByProperty(arr, prop, order = "asc") {
      return [...arr].sort((a, b) => {
        let valA = a[prop];
        let valB = b[prop];
  
        // Handle dates
        if (Date.parse(valA) && Date.parse(valB)) {
          valA = new Date(valA);
          valB = new Date(valB);
        }
  
        if (valA < valB) return order === "asc" ? -1 : 1;
        if (valA > valB) return order === "asc" ? 1 : -1;
        return 0;
      });
    }

  const fetch_data = () => {
    Axios.get("api/estate/equitable/claim/" + client_case_id + "/" + 1)
      .then((res) => {
        setClaims(res.data.data);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>
      <div className="d-flex px-9 align-items-center">
        <div className="ml-auto">
          <CreateEquitableMarital
            setClaims={setClaims}
            client_case_id={client_case_id}
            handleOpen={handleOpen}
          />
        </div>
      </div>
      <div className="pb-10 pl-10 pr-10 pt-0">
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
                      <SortTableHeader 
                        headCells={headCells} 
                        order={order}
                        orderBy={orderBy} 
                        onRequestSort={handleRequestSort}
                        rowCount={claims.length}/>
            <TableBody>
              {claims.map((row) => (
                <EquitableClaimMaritalRow
                  key={row.id}
                  row={row}
                  setClaims={setClaims}
                  client_case_id={client_case_id}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

function EquitableClaimAgainstRow(props) {
  const { row, client_case_id, setClaims } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.description ?? "N/A"}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.value ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.client_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left">
          <ShowNoteComponent row={row} />
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteEquitableMarital row={row} setClaims={setClaims} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'equitable-claim-against'} />
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Which estate has claim? :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.party}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Value of claim :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.value}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      How calculated :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.method}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Notes :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                      {row.notes}
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function EquitableClaimAgainst() {
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetch_data = () => {
    setLoading(true);
    Axios.get("api/estate/equitable/claim/" + client_case_id + "/" + 2)
      .then((res) => {
        setClaims(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>
      <div className="card-title mb-0">
        <div className="d-flex px-9 align-items-center">
          <h6>Equitable Claims in Favor of Either Party's Separate Estate</h6>
          <div className="ml-auto">
            <CreateEquitableMarital
              setClaims={setClaims}
              client_case_id={client_case_id}
              type={2}
            />
          </div>
        </div>
      </div>
      <div className="pb-10 pl-10 pr-10 pt-0">
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                  Description
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Value
                </TableCell>
                {/* <TableCell align="left" className="font-weight-bold text-uppercase text-muted fs-1">Debt</TableCell> */}
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Client SP
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Spouse SP
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Net Value
                </TableCell>
                <TableCell
                  align="left"
                  className="font-weight-bold text-uppercase text-muted fs-1"
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {claims.map((row) => (
                <EquitableClaimAgainstRow
                  key={row.id}
                  row={row}
                  setClaims={setClaims}
                  client_case_id={client_case_id}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {loading && <Loading />}
      </div>
    </>
  );
}

function EquitableClaims(props) {
  const { handleOpen } = props;

  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}>
        <EquitableClaimMarital handleOpen={handleOpen} />
      </div>
    </>
  );
}
export default EquitableClaims;
